import { novaClient } from "@/lib/trpc";

export const useUpdateSetPhoneNumber = () => {
  const novaUtils = novaClient.useUtils();

  return novaClient.internal.user.active.updatePhoneNumber.useMutation({
    onSuccess: async (_updatedUser, { userId }) => {
      await novaUtils.internal.user.active.getCandidacySheetData.invalidate({
        userId,
      });
    },
  });
};
